import { 
  Stamp, 
  Copyright,
  FileText,
  Shield,
  Users,
  FileCheck
} from 'lucide-react';

export const attorneys = [
  // {
  //   id: 1,
  //   name: 'Joseph Lee',
  //   initials: 'JL',
  //   title: 'IP Attorney',
  //   specialization: 'Intellectual Property Law',
  //   icon: Stamp,
  //   bio: 'Joseph Lee is a seasoned intellectual property attorney with decades of experience protecting brands, inventions, and creative works. He counsels clients on all aspects of IP strategy including trademark registration, patent prosecution, copyright protection, and trade secret enforcement. His deep expertise and meticulous approach have made him a trusted advisor for businesses seeking to safeguard their most valuable intangible assets.',
  //   education: 'J.D., Berkeley School of Law',
  //   barAdmissions: ['California State Bar'],
  //   expertise: ['Trademark Registration', 'Patent Prosecution', 'Copyright Protection', 'Trade Secret Enforcement'],
  //   admittedSince: '1992',
  //   location: '77 Monserrat Pl, Foothill Ranch, CA 92610, USA',
  //   focusAreas: 'Brand protection, trademark portfolio management, patent strategy, IP licensing, and trade secret litigation for businesses across all industries.',
  //   memberships: ['American Intellectual Property Law Association', 'California State Bar IP Section']
  // },
  {
    id: 2,
    name: 'Claire McLamore',
    initials: 'CM',
    title: 'IP Attorney',
    specialization: 'Intellectual Property Law',
    icon: Copyright,
    bio: 'Claire McLamore brings a sharp legal mind and a passion for intellectual property to every case. With a Doctor of Jurisprudence from the University of Maryland, she advises clients on trademark clearance, copyright registration, IP enforcement, and anti-counterfeiting strategies. Claire is known for her strategic approach to protecting creative and commercial assets in an increasingly digital marketplace.',
    education: 'J.D., University of Maryland School of Law (Graduated May 2009)',
    barAdmissions: ['Texas State Bar'],
    expertise: ['Trademark Clearance', 'Copyright Registration', 'IP Enforcement', 'Anti-Counterfeiting'],
    admittedSince: '2015',
    location: '2021 7th Ave Fl 11, Seattle, WA 98121, USA',
    focusAreas: 'Trademark prosecution, copyright enforcement, digital IP protection, DMCA compliance, and brand strategy for technology, media, and consumer goods companies.',
    memberships: ['International Trademark Association (INTA)', 'Texas State Bar IP Section']
  }
];

export const paralegals = [
  {
    id: 3,
    name: 'Justin Morrison',
    initials: 'JM',
    title: 'Head of Documentation and Paralegal Operations',
    specialization: 'IP Documentation & Operations',
    icon: FileText,
    bio: 'Justin oversees all documentation workflows and paralegal operations for the firm. He ensures that every filing, registration, and case document meets the highest standards of accuracy and compliance. His leadership keeps the team organized and efficient across all active IP matters.',
    experience: 'Senior operations leader with extensive IP documentation expertise',
    certifications: ['Certified Paralegal (NALA)'],
    skills: ['Documentation Management', 'Team Operations', 'IP Filing Coordination', 'Quality Assurance']
  },
  {
    id: 4,
    name: 'Mark Wilson',
    initials: 'MW',
    title: 'Sr. IP Paralegal',
    specialization: 'Trademark & Patent Support',
    icon: Shield,
    bio: 'Mark provides critical support for trademark and patent filings, managing deadlines, preparing USPTO submissions, and conducting clearance searches. His attention to detail and deep knowledge of IP processes ensure smooth prosecution and portfolio management for clients.',
    experience: 'Senior IP paralegal specializing in trademark and patent support',
    certifications: ['Certified Paralegal (NALA)', 'USPTO Filing Specialist'],
    skills: ['Trademark Clearance Searches', 'USPTO Filings', 'Patent Support', 'Portfolio Management']
  },
  {
    id: 5,
    name: 'Jacob Cole',
    initials: 'JC',
    title: 'Sr. IP Paralegal',
    specialization: 'Copyright & Enforcement',
    icon: FileCheck,
    bio: 'Jacob specializes in copyright registration, DMCA takedown procedures, and IP enforcement support. He assists attorneys with case preparation, evidence gathering, and maintaining detailed records for infringement matters across domestic and international jurisdictions.',
    experience: 'Senior IP paralegal with a focus on copyright and enforcement actions',
    certifications: ['Certified Paralegal (NALA)'],
    skills: ['Copyright Registration', 'DMCA Compliance', 'Infringement Documentation', 'Case Preparation']
  },
  {
    id: 6,
    name: 'Nicole Christian',
    initials: 'NC',
    title: 'Jr. IP Paralegal (Intern)',
    specialization: 'IP Research & Support',
    icon: Users,
    bio: 'Nicole supports the team with IP research, data entry, filing preparation, and administrative tasks. She is building her expertise in intellectual property law while contributing to the firm\'s commitment to thorough and responsive client service.',
    experience: 'Junior paralegal developing skills in intellectual property law',
    certifications: ['Paralegal Studies Certificate'],
    skills: ['IP Research', 'Filing Preparation', 'Data Management', 'Administrative Support']
  }
];

export const allTeamMembers = [...attorneys, ...paralegals];
